import { useParams, useLocation, useNavigate } from "react-router-dom";

import Note from "../notes/Note";
import CreateNoteArea from "../notes/CreateNoteArea";

import CircularProgress from "@mui/material/CircularProgress";
import { useGetNotesWithThatLabelQuery } from "./notesLabelsApiSlice";
import { useEffect } from "react";

function NotesWithLabelList() {
  const navigate = useNavigate();
  const { name } = useParams();
  const location = useLocation();
  const {
    data: notesLabel,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
    currentData,
  } = useGetNotesWithThatLabelQuery(name, "notesList", {
    pollingInterval: 60000,
    refetchOnFocus: true,
    refetchOnMountOrArgChang: true,
  });
  let id;
  useEffect(() => {
    if (location.state == null) {
      navigate("/", { replace: true });
    }
  }, [location.state, navigate]);
  if (location.state !== null) {
    id = location?.state.id;
  }
  let content;
  if (isLoading) {
    content = (
      <CircularProgress
        sx={{ display: "block", textAlign: "center", marginLeft: "50%" }}
      />
    );
  }
  if (isFetching && currentData === undefined) {
    content = (
      <CircularProgress
        sx={{ display: "block", textAlign: "center", marginLeft: "50%" }}
      />
    );
  }
  if (isError) {
    if (error?.data.message) {
      content = (
        <div>
          <CreateNoteArea labelId={id} />
        </div>
      );
    } else {
      content = <p className="errmsg">{error?.data?.message}</p>;
    }
  }
  if (isSuccess && currentData !== undefined) {
    const { ids } = notesLabel;
    const mainContent = ids?.length ? (
      <div>
        <CreateNoteArea labelId={id} />
        {ids.map((noteId) => (
          <Note
            //onDeleteNote={deleteNote}
            key={noteId}
            id={noteId}
            labelId={id}
          />
        ))}
      </div>
    ) : (
      <div>
        <CreateNoteArea labelId={id} />
      </div>
    );
    content = <div id={`labels/${name}`}>{mainContent}</div>;
  }

  return content;
}

export default NotesWithLabelList;
